// extracted by mini-css-extract-plugin
export default {"newPerkInput":"add-perk-input_newPerkInput__nT3rf","error":"add-perk-input_error__QxmUt"};